import { render } from "./AllAskForQuotes.vue?vue&type=template&id=4b74ee69"
import script from "./AllAskForQuotes.vue?vue&type=script&lang=js"
export * from "./AllAskForQuotes.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__